module.exports = __webpack_public_path__ + "img/truck-sm-red.147fb92c.svg";